import { Button, LinearProgress, Switch } from '@mui/material'
import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectAppointmentCalendarSettings,
  setAppointmentCalendarSettingsData,
} from 'src/clinic/reducers/prescription/prescriptionReducer'
import { getAppointmentCalendarSettings } from 'src/clinic/reducers/prescription/services/appointmentCalendarSettings'
import { REDUX_STATUS_LOADING } from 'src/consumer/constants'
import { genericHandleChange } from 'src/consumer/helpers/utilFunctions'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessful,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { postMPDataWithoutParams } from 'src/mentor/services'
import { postSPDataWithParams } from 'src/supportPortal/services/services'

export const AppointmentCalendarSettings = ({
  appointmentCalendarSettingsGetApiSignature = '/api/secure/practitioner/emr-settings/settings/appointment-calendar-settings',
  appointmentCalendarSettingsSaveApiSignature = '/api/secure/practitioner/emr-settings/settings/appointment-calendar-settings/save',
}) => {
  const apptCalendarSettingsData = useSelector(selectAppointmentCalendarSettings)
  const apptCalendarSettings = apptCalendarSettingsData?.data
  const settingsLoading = apptCalendarSettingsData?.status === REDUX_STATUS_LOADING
  const [appointmentCalendarSettings, setAppointmentCalendarSettings] = useState([])
  const [saveLoading, setSaveLoading] = useState(false)
  const dispatch = useDispatch()

  async function getApptCalendarSettings() {
    dispatch(getAppointmentCalendarSettings({ appointmentCalendarSettingsGetApiSignature }))
  }

  function handleChange(e) {
    genericHandleChange(e, setAppointmentCalendarSettings)
  }

  async function saveCalendarSettings() {
    setSaveLoading(true)
    const data = appointmentCalendarSettings
    
    // Check if this is a support portal API
    const isSupportPortalApi = appointmentCalendarSettingsSaveApiSignature.includes('/api/secure/cc/support/')
    
    let response
    if (isSupportPortalApi) {
      // Parse query params from URL if present
      const urlParts = appointmentCalendarSettingsSaveApiSignature.split('?')
      const pathname = urlParts[0]
      const params = {}
      
      // Extract query params if present
      if (urlParts.length > 1) {
        const queryString = urlParts[1]
        const searchParams = new URLSearchParams(queryString)
        searchParams.forEach((value, key) => {
          params[key] = value
        })
      }
      
      response = await postSPDataWithParams(pathname, data, params)
      
      if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
        const respData = response?.data?.data || response?.data || {}
        const appointmentCalendarSettings = respData?.appointmentCalendarSettings || respData
        dispatch(setAppointmentCalendarSettingsData(appointmentCalendarSettings))
      }
    } else {
      // Mentor portal API
      response = await postMPDataWithoutParams(
        appointmentCalendarSettingsSaveApiSignature,
        data,
      )
      if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
        const respData = getDataMapFromCommonResponse(response)?.appointmentCalendarSettings
        dispatch(setAppointmentCalendarSettingsData(respData))
      }
    }
    setSaveLoading(false)
  }

  useEffect(() => {
    getApptCalendarSettings()
  }, [])

  useEffect(() => {
    setAppointmentCalendarSettings(apptCalendarSettings)
  }, [apptCalendarSettings])

  return (
    <div style={{ width: '100%', maxWidth: '768px', paddingBottom: '80px' }}>
      {settingsLoading && <LinearProgress />}
      <div className="pb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-1">
            <div>Show Appointment Number Horizontally in booking listing</div>
          </div>
          <div className="d-flex align-items-center gap-1">
            <Switch
              id="showAppointmentNumberHorizontally"
              checked={appointmentCalendarSettings?.showAppointmentNumberHorizontally ?? false}
              onChange={(e) => handleChange(e)}
            />
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-1">
            <div>Show Patient Visits in booking listing</div>
          </div>
          <div className="d-flex align-items-center gap-1">
            <Switch
              id="showPatientVisits"
              checked={appointmentCalendarSettings?.showPatientVisits ?? false}
              onChange={(e) => handleChange(e)}
            />
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-1">
            <div>Show patients age and gender in booking listing</div>
          </div>
          <div className="d-flex align-items-center gap-1">
            <Switch
              id="showPatientAgeAndGender"
              checked={appointmentCalendarSettings?.showPatientAgeAndGender ?? false}
              onChange={(e) => handleChange(e)}
            />
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-1">
            <div>Show waiting time in booking listing</div>
          </div>
          <div className="d-flex align-items-center gap-1">
            <Switch
              id="showWaitingTime"
              checked={appointmentCalendarSettings?.showWaitingTime ?? false}
              onChange={(e) => handleChange(e)}
            />
          </div>
        </div>
      </div>
      <div className="d-flex" style={{ justifyContent: 'flex-end' }}>
        {!settingsLoading && (
          <Button
            onClick={saveCalendarSettings}
            variant="contained"
            disabled={saveLoading || settingsLoading}
          >
            Save {saveLoading && <Spinner animation="border" variant="light" size="sm" />}
          </Button>
        )}
      </div>
    </div>
  )
}

// {
//   phaseList?.map((phase, idx) => (
//     <Draggable
//       key={`${phase?.id}-${idx}`}
//       draggableId={`${phase?.id}-${idx}`}
//       index={idx}
//       isDragDisabled={mode === 'View'}
//     >
//       {(provided, snapshot) => (
//         <Card {...provided.draggableProps} ref={provided.innerRef} sx={{ mt: 2, px: 2 }}>
//           <PhaseContainer
//             key={idx}
//             phase={phase}
//             setPhase={changePhase}
//             phaseNumber={idx + 1}
//             handleChange={(event) => handleChange(event, idx)}
//             removePhase={removePhase}
//             collapseAllPhases={collapsePhases}
//             disableFields={disabledFields}
//             dragPickProps={provided.dragHandleProps}
//             view={PHASE_VIEW_TYPES.inForm}
//             totalPhases={phaseList?.length}
//             totalDays={customPlan?.totalDays}
//             isDragging={snapshot.isDragging}
//           />
//         </Card>
//       )}
//     </Draggable>
//   ))
// }
